import React, { useState } from "react";
import hipladeTemplate from "../../common/template";
import { Box } from "@mui/material";
import Banner from "../../common/components/banner";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import { useParams } from "react-router-dom";
import EventsService from "../../services/EventsService";
import { toast } from "react-toastify";
// import EventStatus from "../components/EventStatus"; DEPRECIADO
import EventOverview from "../components/EventOverview";
import EventStationsView from "../components/EventStationsView";
import EventAdditionalInformationView from "../components/EventAdditionalInformationView";
import LoaderHiplade from "../../common/components/loaderhiplade";
import palette from "../../common/styles/palette";
import FooterEvent from "../components/footer";
import { useStyles } from "../styles/index.styles";
import secureLocalStorage from "react-secure-storage";

function EventsView() {
  const { eventId } = useParams();
  const stylesEventsView = useStyles();

  const [status, setStatus] = React.useState("");

  const [event, setEvent] = useState<any>("");

  const userRole = secureLocalStorage.getItem("role");

  const getCurrentEvent = async (eventId) => {
    await EventsService.get(eventId)
      .then((response: any) => {
        setEvent(response.data);
        setStatus(response.data.status);
      })
      .catch((e: any) => {
        toast(e?.response?.data?.Error, {
          type: "error",
        });
      });
  };

  React.useEffect(() => {
    if (eventId) {
      getCurrentEvent(eventId);
    }
  }, [eventId]);

  return (
    <Box>
      {/** Banner da Página */}
      <Banner
        type="small"
        image={"medium"}
        title={event?.name}
        icon={
          <VideocamOutlinedIcon
            sx={{ fontSize: "2rem", color: palette.brandForeground, mr: 2 }}
          />
        }
      />
      <Box>
        {event?.id != 0 ? (
          <Box display={"flex"} flexDirection={"column"}>
            <Box className={stylesEventsView.boxContainer}>
              <EventOverview
                status={status}
                event={event}
                getCurrentEvent={getCurrentEvent}
              />
            </Box>
            {userRole == 5 ? null : (
              <Box
                className={stylesEventsView.boxContainer}
                sx={{
                  bgcolor: palette.brandWash,
                  borderRadius: `${palette.radius}px`,
                }}
              >
                <EventAdditionalInformationView
                  statusRoom={status}
                  event={event?.id}
                />
              </Box>
            )}
            <Box className={stylesEventsView.boxContainer}>
              <EventStationsView status={status} event={event} />
            </Box>
          </Box>
        ) : (
          <LoaderHiplade />
        )}
      </Box>
      <FooterEvent />
    </Box>
  );
}

export default hipladeTemplate(EventsView);
